import { Navigate, Outlet } from "react-router-dom";
import { getRoleFromToken } from "@/app/tokenStorage";
import { getDefaultPathForRole, getRolesForNavKey } from "@/app/navigation";

interface RequireRoleProps {
  navKey: string;
}

// Nested inside RequireAuth (see App.tsx), one per route — blocks direct-URL
// access to a page a role doesn't have in its sidebar, not just hiding the
// link. Reads the exact same ROLE_NAV_ITEM_KEYS config the sidebar itself
// filters by (navigation.tsx), so there's one source of truth to extend
// later, not two lists that can drift apart.
export function RequireRole({ navKey }: RequireRoleProps) {
  const role = getRoleFromToken();

  if (!role || !getRolesForNavKey(navKey).includes(role)) {
    return <Navigate to={getDefaultPathForRole(role)} replace />;
  }

  return <Outlet />;
}
